import { render, staticRenderFns } from "./MultiplosServidores.vue?vue&type=template&id=3022452c&scoped=true&"
import script from "./MultiplosServidores.vue?vue&type=script&lang=js&"
export * from "./MultiplosServidores.vue?vue&type=script&lang=js&"
import style0 from "./MultiplosServidores.vue?vue&type=style&index=0&id=3022452c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3022452c",
  null
  
)

export default component.exports